import React from 'react';
import PicksGrupo from '../PicksGrupo/PicksGrupo';
import { ScrollSync, ScrollSyncPane } from 'react-scroll-sync';

import {
  Nav,
  NavItem,
  ControlLabel,
} from 'react-bootstrap/lib';

import Marcadores from '../Marcadores/Marcadores';
import Envivo from '../Envivo/Envivo';
import ChatPanel from '../ChatPanel/ChatPanel';
import {
  MainHeaderPicksGrupo
} from '../../utils/quinielasComponents';
import Utils from '../../utils/quinielasUtils';
import API from '../../utils/api';
import TablaPosiciones from '../TablaPosiciones/TablaPosiciones';
import BracketsUI from '../BracketsUI/BracketsUI';
import picks from '../../assets/images/quinielasIconBlanco-50.png';
import $ from 'jquery';
import PicksGrupoBracket from '../PicksGrupoBracket';
import Premios from '../Premios';
import './bracketPerfectInfoContainer.scss';
import '../BracketPerfect/bracketPerfect.scss';
import BracketResults from '../BracketPerfect/components/BracketPerfectResults';
import BracketPerfect from '../BracketPerfect/BracketPerfect';
import BracketPerfectGroupPicks from '../BracketPerfect/components/BracketPerfectGroupPicks';
import BracketSoccerScoreboard from '../BracketSoccerScoreboard';

const ControlStages = ({ bracketStages, activeStage, changeGroupPickStage }) => {
  const bracketStagesTitles = Object.keys(bracketStages);

  let listStages = bracketStagesTitles.map((title, titleIdx) => {
    if (title !== 'Grupos') {
      if (title === 'Cuartos') {
        return (
          <NavItem className="flex-col col-50" key={title} eventKey={titleIdx + 1}>
            {'Fase final'}
          </NavItem>
        );
      } else {
        return;
      }
    }
    return (
      <NavItem className="flex-col col-50" key={title} eventKey={titleIdx + 1}>
        {title}
      </NavItem>
    );
  });

  return (
    <div className="control-stages-wrapper flex-container justify align column">
      <ControlLabel>
        <i className="ion-ios-information" /> Puedes ver los picks grupales de las diferentes
        etapas.
      </ControlLabel>
      <Nav
        bsStyle="pills"
        id="stages-buttons"
        className="rounds-controls picks-grupos"
        activeKey={activeStage}
        onSelect={changeGroupPickStage}
      >
        {listStages}
      </Nav>
    </div>
  );
};

const MatchTeam = ({ match, home }) => {
  let team = home ? match.home_team : match.away_team;
  let score = home ? match.games_won_home : match.games_won_away;
  return (
    <div className={`table-header-item game-item bs-gp-results text-small text-bold`}>
      {team &&
        <table style={{'tableLayout': 'fixed', 'width': '100%', height: '100%' , vAlign: 'middle'}} className="text-center pick-table-item">
          <tbody>
            <tr>
              <td>
                <i className={`quina ${team.logo}`}></i>
              </td>
              <td>
                { team == null ? (
                    <i className="ion-close" style={{ color: '#E00034' }}></i>
                  ) :
                  team.abbreviation
                }
              </td>
              <td>
                {score}
              </td>
            </tr>
          </tbody>
        </table>
      ||
      <label>PD</label>
      }
    </div>
  )
}

const BSGroupPicksWinningPick = ({ match }) => {
  // upcoming
  if ( match.sort_status == 1 || ( match.sort_status !== 1 && match.winning_pick === null ) ) {
    return (
      <div className='table-header-item game-item bs-group-result text-bold'>
        PD
      </div>
    );
  }
  let winningTeam = null;
  if ( match.winning_pick == match.home_team_id ) {
    winningTeam = match.home_team;
  }
  if ( match.winning_pick == match.away_team_id ) {
    winningTeam = match.away_team;
  }

  return (
    <div className={`table-header-item game-item bs-gp-results text-small text-bold`}>
      <table className="text-center pick-table-item">
        <tbody>
          <tr>
            <td>
              <i className={`quina ${winningTeam.logo}`}></i>
            </td>
            <td>
              {winningTeam.abbreviation}
            </td>
            <td>
              {match.winning_game}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );

};

const UserTieWinning = ({ breaker }) => {
  return (
    <>
      {breaker.enabled &&
        <div className='table-header-item game-item font-chivo text-bold text-italic'>
          <label>{breaker.result !== null ? breaker.result : 'PD'}</label>
        </div>
      ||
        <div className='table-header-item game-item font-chivo text-bold text-italic'>
          <label>PD</label>
        </div>
      }
    </>
  );
}

const MyBracketPicks = ({ match, picks, user, entryId }) => {
  let userPicks = picks.items.find(pick => pick.user_id === user.id && Number(pick.bracket_entry_id) === Number(entryId));
  let userPick = userPicks !== undefined ? userPicks.bracket_picks : null;

  if ( userPick == null || !userPick.hasOwnProperty(match.id) ) {
    return (
      <div className={`table-header-item game-item`}>
        <i className="ion-close" style={{ color: '#E00034' }}></i>
      </div>
    );
  }

  const pick = userPick[match.id];
  // el match no esta vivo
  if ( match.sort_status == 1) {
    return (
      <div className={`table-header-item game-item`}>
        <i className="ion-checkmark" style={{ color: '#78BC28' }}></i>
      </div>
    );
  }

  let selectedTeam = null;
  let selectedWinningTeam = null;
  if ( pick.pick == match.home_team_id ) {
    selectedTeam = match.home_team;
    selectedWinningTeam = match.winning_game;
  }
  if ( pick.pick == match.away_team_id ) {
    selectedTeam = match.away_team;
    selectedWinningTeam = match.winning_game;
  }

  // correct and incorrect pick class
  let pickResultClass = pick.pick == match.winning_pick ? "winner" : "looser";
  let pickNumberGameResultClass =  pick.pick == match.winning_pick && pick.winning_game == match.winning_game ? "winner" : "looser";

  return (
    <div className={`table-header-item game-item bs-gp-results text-small text-bold`}>
      <table style={{'tableLayout': 'fixed', 'width': '100%', height: '100%' , vAlign: 'middle'}} className="text-center pick-table-item">
        <tbody>
          <tr>
            <td className={pickResultClass}>
              <i className={`quina ${selectedTeam?.logo}`}></i>
            </td>
            <td className={pickResultClass}>
              { selectedTeam == null ? (
                  <i className="ion-close" style={{ color: '#E00034' }}></i>
                ) :
                selectedTeam?.abbreviation
              }
            </td>
            <td className={pickNumberGameResultClass}>
              {pick.winning_game === '' ? '-' : pick.winning_game}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}

const MyTieBreakers = ({ userBreaker, breaker, matches }) => {
  if (userBreaker !== undefined) {
    userBreaker = userBreaker.find(ub => ub.bracket_tiebreaker_id === breaker.id);
  }
  //find match
  let matchFinded = undefined;
  if (userBreaker !== undefined) {
    matchFinded = matches.find(match => (match.away_team_id === userBreaker.value || match.home_team_id === userBreaker.value));
  }
  let selectedTeam = null;
  if (matchFinded !== undefined) {
    if ( userBreaker.value == matchFinded.home_team_id ) {
      selectedTeam = matchFinded.home_team;
    }
    if ( userBreaker.value == matchFinded.away_team_id ) {
      selectedTeam = matchFinded.away_team;
    }
  }

  return (
    <div className='table-header-item game-item font-chivo text-bold text-italic'>
      {breaker.enabled &&
        <>
          {(userBreaker === undefined || userBreaker.value === null) &&
            <i className="ion-close" style={{ color: '#E00034' }}></i>
          ||
            <i className="ion-checkmark" style={{ color: '#78BC28' }}></i>
          }
        </>
      ||
        <>
          {selectedTeam !== null ? selectedTeam?.abbreviation : 'ND' }
        </>
      }
    </div>
  );
}

class BracketPerfectInfoContainer extends React.Component {
  constructor(props) {

    super(props);
    let tempState = this.props.estado;
    if (tempState === undefined) {
      tempState = {};
      tempState.actualPage = 0;
      tempState.posActualPage = 0;
      tempState.actualRound = 0;
      tempState.scrollElement = null;
    }

    this.state = tempState;

    this.selectSection = this.selectSection.bind(this);
    this.getAganarBracket = Utils.getAganaBracket.bind(this);
    this.calculateTiesPrizes = Utils.calculateTiesPrizes.bind(this);
    this.nextPageStandings = Utils.nextPageStandings.bind(this);
    this.siguientePagPositions = this.siguientePagPositions.bind(this);
    this.updateStandingsFixturePoints = Utils.updateStandingsFixturePoints.bind(this);
    this.updateStandingsPropsPoints = Utils.updateStandingsPropsPoints.bind(this);
    this.updateStandingsPosition = Utils.updateStandingsPosition.bind(this);
    this.updateStandingsAganar = Utils.updateStandingsAganar.bind(this);
    this.updateState = this.updateState.bind(this);

    this.changeRound = (e) => {
      console.log('%c ChangeRound ', 'color: rgb(213, 210, 57); font-size:2em;');
      console.log(e);
      this.setState({
        activeRound: e,
      });
    };
  }

  /**
   * This function handles a call to the API
   * to get the new page of the positions
   */
  siguientePagPositions(eventKey) {
    console.log('Next Positions...');
    let loaderElement = $('#loading');
    let tempActiveSort = null;
    // console.log(loaderElement);
    if (loaderElement !== undefined && loaderElement.length > 0) {
      loaderElement[0].style.display = 'flex';
    }
    // loading.style.position('flex');
    let temporalPositions = this.props.posiciones.items;
    // console.log('siguiente');
    //let val = eventKey;

    this.props.queryParams.page = this.props.queryParams.page + 1;

    API.fetchBracketStandings(
      this.props.poolInfo.bracket.id,
      this.props.queryParams
    ).then((response) => {
      this.setState(
        (prevState) => {
          console.log(tempActiveSort);
          let newPosiciones = response.data;

          let newItems = response.data.items !== null ? response.data.items : null;

          newItems.forEach((item) => {
            temporalPositions.push(item);
          });

          if (this.props.poolInfo.status === 'live') {
            this.updateStandingsPosition(temporalPositions);
            this.updateStandingsAganar(temporalPositions);
            // temporalPositions.sort(firstBy('total_possibly_correct', -1).thenBy('entry_id'));
          } else {
            // temporalPositions.sort(firstBy('rank').thenBy('entry_id'));
          }

          // console.log('NEWPos',temporalPositions);
          newPosiciones.items = temporalPositions;
          return {
            posiciones: newPosiciones,
            posActualPage: this.props.queryParams + 1,
          };
        },
        () => {
          // if(this.props.sortPositionList !== undefined){
          //   setTimeout( () => {
          //     console.log(tempActiveSort);
          //     this.props.sortPositionList( tempActiveSort, true );
          //   }, 150);
          // }
          if (this.updateScrollPositions !== undefined) {
            this.updateScrollPostions(this.state.posiciones);
          }
          if (loaderElement !== undefined && loaderElement.length > 0) {
            loaderElement[0].style.display = 'none';
            //let avatars = $('.score-avatars').height('auto');
          }
        }
      );
    });
  }

  selectSection(which) {
    let weekId;
    if (this.props.poolInfo.pool === undefined) {
      weekId = null;
    } else {
      if (this.props.poolInfo.pool.type === 'week') {
        if (this.props.poolInfo.pool.week_id === null) {
          weekId = this.props.fixtures[0].week_id;
          if (this.props.poolInfo.tiebreakers[weekId] === undefined) {
            weekId = '';
          }
        } else {
          weekId = this.props.poolInfo.pool.week_id;
        }
      } else if (this.props.poolInfo.pool.type === 'full' && this.props.poolWeekSelected !== null) {
        weekId = this.props.poolWeekSelected;
      } else {
        weekId = this.state.poolWeeks.current.id;
      }
    }
    if (which === undefined) {
      which = 0;
    }

    //which = 2;
    switch (Number(which)) {
      case 0:
        return (
          <div className=" flex-row multiple-quiniela-info principal">
            <div className="flex-col">
              <BracketPerfect
                bracket={this.props.bracketInfo}
                userData={this.props.userData}
                isLogged={this.props.logged}
                showLoginPopUp={this.props.showLoginPopUp}
                showRegister={this.props.showReRegister}
                isPopUp={false}
                matches={this.props.bracketMatches}
                stages={this.props.bracketStages}
                groups={this.props.bracketGroups}
                standings={this.props.standings}
                tickets={this.props.bracketTickets}
                siguientePagPositions={this.props.siguientePagPositions}
                updateUserInfo={this.props.updateUserInfo}
                selectedEntryData={this.props.selectedEntryData}
                entryId={
                  this.props.selectedEntry !== null &&
                  this.props.selectedEntry !== undefined
                    ? this.props.selectedEntry
                    : null
                }
                refreshAfterGuardar={this.props.refreshAfterGuardar}
                showAbonar={this.props.showAbonar}
              />
            </div>
          </div>
        );
        break;
      case 1:
        return (
          <div className="flex-row multiple-quiniela-info principal">
            <div className="first-section col-xs-12 col-sm-6">
              <TablaPosiciones
                isVisible={true}
                actualPage={this.state.posActualPage}
                changeSearchNick={this.props.changeSearchNick}
                entryId={this.props.selectedEntry}
                entry={this.props.selectedEntryData}
                fetchSearchableStandings={this.props.fetchSearchableStandings}
                loaded={this.props.loaded}
                nextPageStandings={this.props.nextPageStandings}
                poolInfo={this.props.bracketInfo}
                activeStage={this.props.activeStage}
                posiciones={this.props.standings}
                resetNickValue={this.props.resetNickValue}
                siguientePagPositions={this.props.siguientePagPositions}
                selectedEntry={this.props.selectedEntry}
                standings={this.props.standings}
                submittingSearch={this.props.submittingSearch}
                type="bracket"
                userData={this.props.userData}
                activeSort={this.props.activeSort}
                getAganar={this.getAganarBracket}
                premios={this.props.bracketPrizes}
                sortPositionList={this.props.sortPositionList}
                tiesDistribution={this.props.bracketTiesDistribution}
                calculateTiesPrizes={this.calculateTiesPrizes}
              />
            </div>

            <div className="second-section col-xs-12 col-sm-3">
              {this.props.logged ? (
                <ChatPanel
                  gameType="bracket"
                  entries={this.props.entries}
                  handleMessage={this.props.handleMessage}
                  handleMaxHeight={this.props.handleMaxHeight}
                  loaded={this.props.loaded}
                  logged={this.props.logged}
                  newMessage={this.props.newMessage}
                  selectedEntry={this.props.selectedEntry}
                  resetMessage={this.props.resetMessage}
                  quinielaID={this.props.bracketInfo.id}
                  sendMessage={this.props.sendMessage}
                  userAvatar={this.props.logged ? this.props.userData : null}
                  userNick={this.props.logged ? this.props.userData.nick : null}
                  withRegister={this.props.withRegister}
                />
              ) : (
                <div className="message-not-logged">
                  {' '}
                  Necesitas Ingresar para poder usar el chat
                </div>
              )}
            </div>

            <div className="col-xs-12 col-sm-3 border-gradient" style={{margin: '14px 8px'}}>
              <Premios
                weeks={null}
                estado={this.props.loaded}
                loaded={this.props.loaded}
                poolInfo={this.props.bracketInfo}
                poolWeekSelected={null}
                premios={this.props.bracketPrizes}
                standGroups={this.props.bracketGroupPicksSeries}
                standings={this.props.standings}
                type="lobby"
                game="series"
              />
            </div>
          </div>
        );
        break;
      case 2:
        return (
          <BracketPerfectGroupPicks
            currentStage={this.props.bracketCurrentStage}
            bracketStages={this.props.bracketStages}
            bracketTeams={this.props.bracketTeams}
            matches={this.props.bracketMatches}
            selectedEntryData={this.props.selectedEntryData}
            bracketInfo={this.props.bracketInfo}
            entryId={this.props.selectedEntry}
            groupPicks={this.props.bracketGroupPicks}
            // eventHandlers
            onStageChange={this.props.onStageChange}
            loadMoreStandings={this.props.loadMoreStandings}
          />
        );
        break;
      case 3:
        return (
          <div className="multiple-quiniela-info marcadores">
            <div className="first-section col-xs-12 col-md- 6">
              <BracketSoccerScoreboard bracket={this.props.bracketInfo} webSocket={this.props.webSocket}></BracketSoccerScoreboard>
            </div>
          </div>
        );
        break;
      case 4:
        return (
          <div className="multiple-quiniela-info live">
            <div className="first-section col-xs-12">
              <Envivo
                liveFixturesData={this.props.liveFixturesData}
                fixtures={this.state.fixtures}
                logged={this.state.logged}
                poolInfo={this.state.poolInfo}
                userData={this.state.userData}
                posiciones={this.props.posiciones}
                premios={this.state.premios}
                standGroups={this.state.standGroups.groups}
              />
            </div>
          </div>
        );
        break;
    }
  }

  componentDidUpdate(prevProps, prevState) {

  }

  updateState() {

  }

  componentDidMount() {
    this.setState({
      premios: this.props.bracketPrizes,
    });
  }

  render() {
    let conditionalComponent = this.selectSection(this.props.selection);
    return conditionalComponent;
  }
}

export default BracketPerfectInfoContainer;
